import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowUpRightFromSquareSharp = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.757 4h8.241v8.24h-2V7.415l-6.331 6.332-.707.707-1.415-1.415.707-.707L16.584 6h-4.827V4ZM9.548 8.882h-1L6 8.885v9.117h9.116v-3.548h2V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.885a1 1 0 0 1 1-1l3.547-.002 1-.001.001 2Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowUpRightFromSquareSharp);
export default Memo;
